<template>
  <header
    class="bg-royal-blue-100"
    data-testid="app-header">
    <div class="container flex items-center justify-between py-4">
      <span
        class="font-bitter text-2xl font-bold text-white"
        data-testid="app-name">
        <nav aria-label="RSC Submissions">
          <a
            href="/submission"
            id="lnk-siteHeader-articleType"
            class="text-white">
            RSC Submissions
          </a>
        </nav>
      </span>
      <ApplicationLogo />
    </div>
  </header>
  <MaintenanceBanner />
</template>

<script setup lang="ts">
import ApplicationLogo from '../images/svg/RSClogo.vue'
import MaintenanceBanner from '@/components/maintenance-banner.vue'
</script>
